module.exports = __webpack_public_path__ + "static/media/Arcade_6512.1f56b66c.jpg";